import ListAveragesBox from './ListAveragesBox'

export default ListAveragesBox
